export default {"src":"/_next/static/media/error-icon.bf3eb545.svg","height":196,"width":201,"blurWidth":0,"blurHeight":0};